<!--
  Template-Mode page header (model name + status badge).
  MUST stay at top level, outside any guard, so @ViewChild('headerTemplate') resolves.
  Conditional content is guarded INSIDE the template.
-->
<ng-template #headerTemplate>
    @if (objectIdentifier) {
        <div class="flex justify-content-between w-full align-items-center surface-0 px-4 py-3">
            <div class="flex align-items-center gap-3">
                <i class="fa-light fa-coins fa-2x"></i>
                <div>
                    <!-- Model name + rich status badge / Freigabevermerk are rendered in the
                         object component's "Allgemein" section (CommissionModelStatus + approvedBy/approvedAt). -->
                    <h5 class="mb-0">Provisionsmodell</h5>
                </div>
            </div>
        </div>
    }
</ng-template>

<!-- Page body: hosts the CommissionModel object component once the identifier is resolved (FR-8). -->
@if (objectIdentifier) {
    <mvs-cn-commission-model-object-component
            [objectIdentifier]="objectIdentifier">
    </mvs-cn-commission-model-object-component>
}
